// import Vue from 'vue'
// import Vuex from 'vuex'

import {
  localStorage,
  cookieStorage
} from '../common/storage'
let store = {
  state: {
    userId: JSON.stringify(cookieStorage.get('domainUserId')) === '{}' ? '' : cookieStorage.get('domainUserId'),
    userPhone: JSON.stringify(cookieStorage.get('domainUserPhone')) === '{}' ? '' : cookieStorage.get('domainUserPhone'),
    userPicpath: JSON.stringify(cookieStorage.get('domainUserPicpath')) === '{}' || cookieStorage.get('domainUserPicpath') === null ? '../../../static/image/userlogo.png' : cookieStorage.get('domainUserPicpath'),
    // userVerity:JSON.stringify(cookieStorage.get('domainUserVetify')) == '{}'? null:cookieStorage.get('domainUserVetify'),
    isLogin: JSON.stringify(cookieStorage.get('domainisLogin')) == '{}' ? false : cookieStorage.get('domainisLogin'),
    istrue: JSON.stringify(cookieStorage.get('headerIsTrue')) == '{}' ? true : cookieStorage.get('headerIsTrue')
  },
  mutations: {
    setUserId(state, data) {
      state.userId = data;
    },
    setUserPhone(state, data) {
      state.userPhone = data;
    },
    setUserPicpath(state, data) {
      state.userPicpath = data;
    },
    setIsTRue(state, data) {
      state.istrue = data;
    },
    // setUserVetify(state,data){
    //     state.userVerity = data;
    // },
    setUserLogin(state, data) {
      state.isLogin = data;
    }
  },
  actions: {
    // 登录
    userId({
      commit
    }, data) {
      commit('setUserId', data);
    },
    userPhone({
      commit
    }, data) {
      commit('setUserPhone', data);
    },
    userPicpath({
      commit
    }, data) {
      commit('setUserPicpath', data);
    },
    // uservetify( {commit},data){
    //     commit('setUserVetify',data);
    //   },
    userLogin({
      commit
    }, data) {
      commit('setUserLogin', data);
    },
    isTure({
      commit
    }, data) {
      commit('setIsTRue', data);
    }
  }
}
export default store;




// WEBPACK FOOTER //
// ./src/store/index.js